import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import React, {useEffect, useRef, useState} from "react";
import {v4} from "uuid";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import {Checkbox, FormControlLabel} from "@mui/material";
import Stack from "@mui/material/Stack";
import {ICharArmor} from "../../_interfaces/ICharArmor";
import {s_char_armor} from "../../_signals/s_char";
import {modArmor} from "../../_signals/s_char_mods";
import {ArmorDelete, ArmorUpdate} from "../../_api/BEArmor";

interface IProp {
    edit: string,
    isOpen: (id: string) => void
}

function ArmorEdit({edit, isOpen}: IProp) {

    const mod_15 = [...Array(16).keys()];

    const descRef = useRef<HTMLInputElement>(null);

    const [armor, setArmor] = useState<ICharArmor | null>(null);

    useEffect(() => {
        const fw = s_char_armor.value.find(d => d.id === edit);
        if (fw) {
            setArmor(fw)
        } else setArmor(null)
    }, [edit])


    const save = () => {

        let charArmor = s_char_armor.value

        const found = charArmor.findIndex(x => x.id === armor?.id);

        if (found >= 0) {
            charArmor[found].descr= descRef.current?.value as string
            modArmor(charArmor[found]);
            ArmorUpdate(charArmor[found])
            s_char_armor.value = charArmor
        }
        isOpen('')
    }

    const cancel = () => {
        isOpen('')
    }

    const remove = () => {
        const id = armor?.id;

        if (!id) return

        let charArmor = s_char_armor.value

        let f = charArmor.findIndex(x => x.id === id) as number;

        if (f >= 0) {
            modArmor(charArmor[f]);

            isOpen('');

            ArmorDelete(charArmor[f])

            charArmor.splice(f, 1);
            s_char_armor.value = charArmor
        }
    }

    return <Dialog open={edit !== ''}>
        <DialogContent>
            <div>{armor?.name}</div>

            <TextField style={{width: '100%', marginTop: 8}}
                       defaultValue={armor?.descr||''}
                       label={'Beschreibung'}
                       inputRef={descRef}>
            </TextField>

            <Stack style={{width: '100%', marginTop: 8}} direction={'row'}>
                <FormControlLabel style={{marginLeft: 0}} control={
                    <Checkbox defaultChecked={armor?.wear || false}
                              onChange={
                                  (e) => {
                                      let curr = armor;
                                      if (curr) {
                                          curr.wear = e.target.checked;
                                          setArmor(curr)
                                      }
                                  }
                              }/>
                } label="getragen"/>

                <FormControl sx={{m: 1, minWidth: 120}}>
                    <InputLabel id="pr_mod_label">Modifikator physische Rüstung</InputLabel>
                    <Select defaultValue={armor?.pr_mod||0}
                            labelId="pr_mod_label"
                            style={{width: "100%"}}
                            onChange={
                                (e) => {
                                    let curr = armor;
                                    if (curr) {
                                        curr.pr_mod = e.target.value as number;
                                        setArmor(curr)
                                    }
                                }
                            }
                    >
                        {mod_15.map(m => <MenuItem key={v4()} value={m}>{m}</MenuItem>)}
                    </Select>
                </FormControl>
                <FormControl sx={{m: 1, minWidth: 120}}>
                    <InputLabel id="mr_mod_label">Modifikator mystische Rüstung</InputLabel>
                    <Select defaultValue={armor?.mr_mod||0}
                            labelId="mr_mod_label"
                            style={{width: "100%"}}
                            onChange={
                                (e) => {
                                    let curr = armor;
                                    if (curr) {
                                        curr.mr_mod = e.target.value as number;
                                        setArmor(curr)
                                    }
                                }
                            }
                    >
                        {mod_15.map(m => <MenuItem key={v4()} value={m}>{m}</MenuItem>)}
                    </Select>
                </FormControl>
                <FormControl sx={{m: 1, minWidth: 120}}>
                    <InputLabel id="ini_mod_label">Modifikator Initiative</InputLabel>
                    <Select defaultValue={armor?.ini_mod||0}
                            labelId="ini_mod_label"
                            style={{width: "100%"}}
                            onChange={
                                (e) => {
                                    let curr = armor;
                                    if (curr) {
                                        curr.ini_mod = e.target.value as number;
                                        setArmor(curr)
                                    }
                                }
                            }
                    >
                        {mod_15.map(m => <MenuItem key={v4()} value={m}>{m}</MenuItem>)}
                    </Select>
                </FormControl>
            </Stack>
        </DialogContent>
        <DialogActions>
            <Button className={'btn'} id="post" onClick={() => save()}><CheckIcon/></Button>
            <Button className={'btn'} id="post" onClick={() => cancel()}><ClearIcon/></Button>
            <Button className={'btn'} id="post" onClick={() => remove()}>
                <DeleteOutlineIcon/>
            </Button>
        </DialogActions>
    </Dialog>

}

export default ArmorEdit

